<template>
    <div>
        <Header title="发布文章" />
        <div class="publish-form-wrap">
            <div class="add-item-wrap add-cover-wrap">
                <van-uploader class="flex ccc pos-r" :max-size="uploaderMaxSize.imageMaxSize * 1024" @oversize="_onOversize" :after-read="_afterReadPhoto('cover')">
                    <img :src="cover" alt="" class="cover-img" v-if="cover" />
                    <div class="pos-a upload-tips-wrap text-c flex ccc w100 h100">
                        <p class="van-icon van-icon-photograph"></p>
                        <p class="upload-btn-title">选择封面图片</p>
                    </div>
                </van-uploader>
            </div>
            <div class="add-item-wrap add-category-wrap">
                <van-cell is-link title="文章分类" :value="selectCate.name || '请选择'" @click="isShowCategory = true" />
                <van-action-sheet v-model="isShowCategory" :actions="categoryActions" cancel-text="取消" description="文章分类" close-on-click-action @select="_onSelectCate" />
            </div>
            <div class="add-item-wrap add-title-wrap">
                <van-field class="title" v-model="name" placeholder="请输入文章标题" :border="false" />
            </div>
            <div class="add-item-wrap add-desc-wrap">
                <van-field v-model="overview" type="textarea" placeholder="请填写简述" :border="false" />
            </div>
            <div class="add-item-wrap pos-r" :class="`add-con-${item.type}-wrap`" v-for="(item, index) in fields" :key="index">
                <div class="pos-a van-icon van-icon-close" @click="onPressDel(index)"></div>
                <div class="item-con-wrap" v-if="item.type === 'title'">
                    <van-field class="title" v-model="item.value" placeholder="请输入文章标题" :border="false" />
                </div>
                <div class="item-con-wrap" v-if="item.type === 'text'">
                    <van-field class="text" v-model="item.value" type="textarea" placeholder="请输入文章内容" :autosize="true" :border="false" />
                </div>
                <div class="item-con-wrap" v-if="item.type === 'image'">
                    <van-uploader class="item-uploader-wrap" :accept="'image/*'" :max-size="uploaderMaxSize.imageMaxSize * 1024" @oversize="_onOversize" :after-read="_afterReadPhoto(index)">
                        <img :src="item.value" v-if="item.value" />
                        <div class="pos-a upload-tips-wrap text-c flex rcc w100 h100" v-else>
                            <p class="van-icon van-icon-photograph"></p>
                            <p class="upload-btn-title">选择图片</p>
                        </div>
                    </van-uploader>
                </div>
                <div class="item-con-wrap" v-if="item.type === 'video'">
                    <van-uploader class="item-uploader-wrap" :accept="'video/*'" :max-size="uploaderMaxSize.videoMaxSize * 1024" @oversize="_onOversizeVideo" :after-read="_afterReadPhoto(index)">
                        <img :src="item.value + Constants.VIDEO_FRAME" v-if="item.value" />
                        <div class="pos-a upload-tips-wrap text-c flex rcc w100 h100" v-else>
                            <p class="van-icon van-icon-photograph"></p>
                            <p class="upload-btn-title">选择视频</p>
                        </div>
                    </van-uploader>
                </div>
            </div>
        </div>
        <div class="btn-wrap pos-f w100">
            <div class="push">
                <div @click="onPressAdd('title')">
                    <img :src="Images.icon_add_title" alt="">
                    <p>插入标题</p>
                </div>
                <div @click="onPressAdd('text')">
                    <img :src="Images.icon_add_text" alt="">
                    <p>插入文本</p>
                </div>
            </div>
            <div class="push">
                <div @click="onPressAdd('image')">
                    <img :src="Images.icon_add_png" alt="">
                    <p>插入图片</p>
                </div>
                <div @click="onPressAdd('video')">
                    <img :src="Images.icon_add_video" alt="">
                    <p>插入视频</p>
                </div>
            </div>
            <div class="btn" @click="onPressSubmit">发布文章</div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Header from '@/components/Header'
import {
    QiniuUpload
} from '@/utils/qiniuUpload'
export default {
    components: {
        'Header': Header,
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            id: this.$route.query.id,
            qiniuInfo: {},
            uploaderMaxSize: {},
            selectCate: {},
            name: '',
            cover: '',
            overview: '',
            fields: [],
            errorMsg: {
                'title': '请输入或删除标题模块',
                'text': '请输入或删除文本模块',
                'image': '请上传或删除图片模块',
                'video': '请上传或删除视频模块',
            },
            isShowCategory: false,
            categoryActions: [],
        };
    },
    mounted() {
        this.getQiniuData();
        this._requestCategoryData();
    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if (!url) return;
            window.location.href = url;
        },

        // 获取七牛云配置
        async getQiniuData() {
            let url = this.API.qiniuToken;
            let params = {};
            let result = await this.$post(url, params);
            this.qiniuInfo = result;
            this.uploaderMaxSize = result.uploaderMaxSize;
        },

        // 获取分钟分类
        async _requestCategoryData() {
            let url = this.API.category_list;
            let params = {};
            let result = await this.$post(url, params);
            this.categoryActions = result.data.data;
            // this.categoryArr.forEach((item, index) => {
            //     this.categoryActions[]
            // });
        },
        
        _onOversize(file) {
            console.log('file---->', file);
            this.ToastManager('图片大小不能超过：' + (this.uploaderMaxSize.imageMaxSize / 1024) + 'M');
        },
        
        _onOversizeVideo(file) {
            console.log('file---->', file);
            this.ToastManager('视频大小不能超过：' + (this.uploaderMaxSize.videoMaxSize / 1024) + 'M');
        },

        // 上传视频
        _afterReadPhoto(index) {
            return (file) => {
                console.log('file, index---->', file, index);
                this.ToastManager.loading({
                    duration: 0,
                    message: '上传中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                // 此时可以自行将文件上传至服务器
                if (this.IMAGES_DRIVER == this.Constants.DRIVER_QINIUKODO) {
                    QiniuUpload(this.qiniuInfo, file).then((res) => {
                            let fileUri = this.qiniuInfo.domain + res.key;
                            this.updateData(fileUri, index);
                            setTimeout(() => {
                                this.ToastManager.clear()
                            }, 500);

                        })
                        .catch((err) => {
                            console.log('err------------->', err)
                        });
                }
                if (this.IMAGES_DRIVER == this.Constants.DRIVER_ALIOSS) {
                    this._onUploadImageToAliOss(file, index);
                }
                if (this.IMAGES_DRIVER == this.Constants.DRIVER_TENCENTCOS) {

                }
            }
            // console.log('file, index---->', file, index);
        },

        // 上传阿里云
        async _onUploadImageToAliOss(file, index) {
            let url = this.API.uploadToAliOss;
            let params = {
                file: file.file,
                uid: this.userInfo.id,
            };
            this.Message({
                message: "上传中",
                type: 4,
                time: 500,
            });
            let result = await this.$uploadFormData(url, params);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                this.updateData(result.url, index);
                setTimeout(() => {
                    this.ToastManager.clear()
                }, 500);
            }
        },

        updateData(fileUri, index) {
            if (index == 'cover') {
                this.cover = fileUri;
            } else {
                this.fields[index].value = fileUri;
            }
        },

        // 插入内容
        onPressAdd(type) {
            let {
                fields
            } = this;
            let array = fields.slice();
            array.push({
                type: type,
                value: ''
            })
            this.fields = array
        },
        // 删除内容
        onPressDel(index) {
            let array = this.fields.slice();
            array.splice(index, 1);

            console.log('array---->', array);
            this.fields = array;
        },

        _onSelectCate(action, index) {
            console.log('action, index---->', action, index);
            this.selectCate = action;
        },

        // 发布任务
        async onPressSubmit() {

            let url = this.API.save_my_article;
            let params = {
                id: this.id,
                name: this.name,
                cover: this.cover,
                fields: this.fields,
                overview: this.overview,
                category_id: this.selectCate.id,
            };

            if (!this.cover) return this.ToastManager('请上传文章封面');
            if (!this.selectCate.id) return this.ToastManager('请选择文章类型');
            if (!this.name) return this.ToastManager('请输入文章标题');


            // 判断内容是否添加
            let checkStatus = true;
            this.fields.every((item) => {
                if (!item.value) {
                    checkStatus = false;
                    this.ToastManager(this.errorMsg[item.type])
                    return checkStatus;
                } else {
                    return checkStatus;
                }
            })

            if (!checkStatus) return;

            let result = await this.$post(url, params);
            this.ToastManager(result.msg);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                setTimeout(() => {
                    this._onBack();
                }, 1000);
            }
        },
    },
};
</script>
<style lang="less" scoped>
.publish-form-wrap {
    padding-bottom: 16rem;

    .van-uploader {
        height: 100%;
        display: flex;
        min-height: 6rem;
        align-items: center;
        justify-content: center;

        .upload-tips-wrap {
            top: 0;
            background: #0000000f;
            border-radius: 0.5rem;

            .van-icon {
                width: 2rem;
                height: 2rem;
                color: #333;
                font-size: 2rem;
            }

            .upload-btn-title {
                color: #333;
                margin-top: 1rem;
                white-space: nowrap;
            }
        }

        ::v-deep .van-uploader__input {
            z-index: 99;
        }
    }

    .add-item-wrap {
        margin: 1rem 1rem;
        background: #fff;
        padding: 1rem 1.6rem;
        border-radius: 0.5rem;

        .van-cell {
            padding: 0;

            &::after {
                display: none;
            }
        }

        .van-icon-close {
            z-index: 1;
            top: -.5rem;
            right: -.5rem;
            color: #f00;
            font-size: 2rem;
            background: #fff;
            border-radius: 50%;
        }
    }

    .add-cover-wrap {
        height: 10rem;

        .cover-img {
            z-index: 9;
            height: 100%;
            position: relative;
        }
    }

    .item-con-wrap {
        .van-uploader {
            .upload-tips-wrap {
                .van-icon {}

                .upload-btn-title {
                    margin-top: 0;
                    margin-left: 1rem;
                }
            }

            ::v-deep .van-uploader__wrapper,
            ::v-deep .van-uploader__input-wrapper,
            ::v-deep .van-uploader__input {
                min-height: 6rem;
            }
        }
    }

}


.btn-wrap {
    bottom: 0;
    z-index: 99;
    padding: 1rem 1rem 2rem;
    background: #f8f8f8;
    box-sizing: border-box;

    .push {
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;

        >div {
            flex: 1;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;

            >img {
                width: 22px;
                height: 22px;
                margin-right: 6px;
            }

            >p {
                font-size: 14px;
                color: #333;
            }
        }
    }

    .btn {
        height: 40px;
        border-radius: 3px;
        background: linear-gradient(225deg, #9cb2f4, #6472e8);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        color: #fff;
    }
}
</style>